import { AddressFields } from 'ui-kit/form/interfaces/AddressModal';
import { TransfereeParty } from '../../types';
import { CountryCode } from '@agentnet/utils';

export const getInitialPartyData = (): TransfereeParty => ({
  partyType: 'beneficialOwner',
  isMinor: false,
  firstName: '',
  middleName: '',
  lastName: '',
  suffix: '',
  dateOfBirth: '',
  address: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: CountryCode.US,
    postalCode: '',
  } as AddressFields,
  foreignPrincipalAddress: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: CountryCode.US,
    postalCode: '',
  } as AddressFields,
  identificationType: '',
  identificationNumber: '',
  issuingJurisdiction: '',
  beneficialOwnerCategory: '',
  citizenshipCountry: [CountryCode.US],
  status: 'incomplete',
  dateOfTrustInstrument: '',
  isRevocableTrust: false,
  beneficialOwnerCitizenship: '',
  addressType: '',
  foreignBusinessNoUSLocation: false,
});
